var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGlobeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.00341797,
    y: 0.00341797,
    width: 48.0046,
    height: 48.0046,
    rx: 24.0023,
    fill: "#45B549"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.75 24.5C27.75 25.3984 27.6719 26.2188 27.5938 27H20.3672C20.2891 26.2188 20.2109 25.3984 20.2109 24.5C20.2109 23.6406 20.2891 22.8203 20.3672 22H27.5938C27.6719 22.8203 27.75 23.6406 27.75 24.5ZM33.6484 22C33.8828 22.8203 34 23.6406 34 24.5C34 25.3984 33.8828 26.2188 33.6484 27H28.8438C28.9219 26.2188 29 25.3594 29 24.5C29 23.6406 28.9219 22.8203 28.8438 22H33.6484ZM33.2578 20.75H28.6875C28.2969 18.2891 27.5156 16.1797 26.5391 14.8516C29.5859 15.6719 32.0859 17.8594 33.2578 20.75ZM27.4375 20.75H20.5234C20.7578 19.3438 21.1484 18.0938 21.5781 17.0781C22.0078 16.1406 22.4375 15.4766 22.9062 15.0469C23.3359 14.6562 23.6875 14.5 24 14.5C24.2734 14.5 24.625 14.6562 25.0547 15.0469C25.5234 15.4766 25.9531 16.1406 26.3828 17.0781C26.8125 18.0938 27.2031 19.3438 27.4375 20.75ZM14.7031 20.75C15.875 17.8594 18.375 15.6719 21.4219 14.8516C20.4453 16.1797 19.6641 18.2891 19.2734 20.75H14.7031ZM19.1172 22C19.0391 22.8203 18.9609 23.6406 18.9609 24.5C18.9609 25.3594 19.0391 26.2188 19.1172 27H14.3125C14.0781 26.2188 14 25.3984 14 24.5C14 23.6406 14.0781 22.8203 14.3125 22H19.1172ZM21.5781 31.9609C21.1484 30.9453 20.7578 29.6953 20.5234 28.25H27.4375C27.2031 29.6953 26.8125 30.9453 26.3828 31.9609C25.9531 32.8984 25.5234 33.5625 25.0547 33.9922C24.625 34.3828 24.2734 34.5 23.9609 34.5C23.6875 34.5 23.3359 34.3828 22.9062 33.9922C22.4375 33.5625 22.0078 32.8984 21.5781 31.9609ZM21.4219 34.1875C18.375 33.3672 15.875 31.1797 14.7031 28.25H19.2734C19.6641 30.75 20.4453 32.8594 21.4219 34.1875ZM26.5391 34.1875C27.5156 32.8594 28.2969 30.75 28.6875 28.25H33.2578C32.0859 31.1797 29.5859 33.3672 26.5391 34.1875Z",
    fill: "#FCFCFC"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobeIcon);
export default __webpack_public_path__ + "static/media/GlobeIcon.c3fe79289814d676c022c143a8795910.svg";
export { ForwardRef as ReactComponent };